import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { END_POINT } from '../../const/endpoint';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  constructor(private http: HttpClient) { }

  login(params: { username: string, password: string }): Promise<any> {
    return this.http.post(END_POINT.USERS.LOGIN, params).toPromise();
  }

  getUsers(idUsuario: any): Promise<any> {
    return this.http.get(END_POINT.USERS.LIST, { params: { idUsuario }}).toPromise();
  }

  saveUser(user: any): Promise<any> {
    return this.http.post(END_POINT.USERS.ADD, user).toPromise();
  }

  updateUser(user: any): Promise<any> {
    return this.http.put(END_POINT.USERS.EDIT, user).toPromise();
  }

  deactiveUser(idUsuario: any): Promise<any> {
    return this.http.post(END_POINT.USERS.DEACTIVE_USER, { idUsuario }).toPromise();
  }

  activeUser(idUsuario: any): Promise<any> {
    return this.http.post(END_POINT.USERS.ACTIVE_USER, { idUsuario }).toPromise();
  }

  resetMinutes(idUsuario: any, idUsuarioLogin: string): Promise<any> {
    return this.http.post(END_POINT.USERS.RESET_MINUTES, { idUsuario, idUsuario_login: idUsuarioLogin }).toPromise();
  }

  addMinutesToUser(params: any): Promise<any> {
    return this.http.post(END_POINT.USERS.ADD_MINUTES, params ).toPromise();
  }

  deleteUser(idUsuario: any): Promise<any> {
    const form = new FormData();
    form.append('idUsuario', idUsuario);

    return this.http.request('DELETE', END_POINT.USERS.DELETE, { body: form }).toPromise();
  }

  getPackageMinutes(idUsuario: any): Promise<any> {
    return this.http.get(END_POINT.USERS.GET_MINUTES, { params: { idUsuario }} ).toPromise();
  }

  recoverPassword(email: string): Promise<any> {
    return this.http.post(END_POINT.USERS.RECOVER_PASSWORD, { email } ).toPromise();
  }

  validateHashRecoverPassword(hash: string): Promise<any> {
    return this.http.get(`${END_POINT.USERS.VALIDATE_HASH_RECOVER_PASSWORD}${hash}`).toPromise();
  }

  changePassword(email: string, hash: string): Promise<any> {
    return this.http.post(END_POINT.USERS.CHANGE_PASSWORD, { Nuevacontrasena: email, hash } ).toPromise();
  }

  getConsumption(idUsuario: string, initDate: string, finishDate: string, idArea: any, usuarioFiltro: any): Promise<any> {
    return this.http.get(END_POINT.USERS.GET_CONSUMPTION, {
      params: {
        idUsuario,
        initDate,
        finishDate,
        idArea,
        usuario_busqueda: usuarioFiltro
      }
    } ).toPromise();
  }
}
